export const SrpShareIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      transform="translate(6, 4) scale(1.5)"
      d="M15.529 0.0185051C15.6579 -0.0243807 15.7992 0.00849725 15.8952 0.104443C15.992 0.20044 16.025 0.341743 15.9821 0.470654L13.444 8.11323L10.9049 15.7548C10.8609 15.8878 10.7432 15.983 10.6032 15.998C10.4644 16.0128 10.3294 15.9469 10.2575 15.8261L7.91665 11.9248L5.59731 12.6406C5.48947 12.6735 5.37185 12.6546 5.27993 12.5869C5.18893 12.5199 5.13443 12.4118 5.13442 12.2988V8.80561C5.13444 8.77864 5.14305 8.75347 5.15005 8.72749L0.173483 5.74116C0.0535515 5.66914 -0.0134105 5.53442 0.00258483 5.39546C0.0176444 5.25553 0.1128 5.13866 0.245749 5.09468L15.529 0.0185051Z"
      fill="black"
      fillOpacity="0.5"
    />
    <g filter="url(#srpShareDropShadow)">
      <path
        transform="translate(6, 4) scale(1.5)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.529 0.0185051C15.6579 -0.0243807 15.7992 0.00849725 15.8952 0.104443C15.992 0.20044 16.025 0.341743 15.9821 0.470654L13.444 8.11323L10.9049 15.7548C10.8609 15.8878 10.7432 15.983 10.6032 15.998C10.4644 16.0128 10.3294 15.9469 10.2575 15.8261L7.91665 11.9248L5.59731 12.6406C5.48947 12.6735 5.37185 12.6546 5.27993 12.5869C5.18893 12.5199 5.13443 12.4118 5.13442 12.2988V8.80561C5.13444 8.77864 5.14305 8.75347 5.15005 8.72749L0.173483 5.74116C0.0535515 5.66914 -0.0134105 5.53442 0.00258483 5.39546C0.0176444 5.25553 0.1128 5.13866 0.245749 5.09468L15.529 0.0185051ZM7.18813 9.31831L10.4704 14.789L12.7633 7.88667L14.8249 1.68257L7.18813 9.31831ZM5.85024 11.8134L7.53774 11.2919L6.47524 9.52339L5.85024 9.14741V11.8134ZM8.11294 3.23628L1.21157 5.52925L6.6813 8.81147L14.319 1.17476L8.11294 3.23628Z"
        fill="white"
        stroke="white"
        strokeWidth="0.65"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="srpShareDropShadow"
        x="0"
        y="0"
        width="36"
        height="36"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);
